import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OrganizationsService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router

  ) { }

  fetchOrganizations() {
    const endpoint = environment.apiUrl + "/api/organizations";

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken();
    return this.http.get(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken) });
  }

  getOrganization(id: number) {
    const endpoint = environment.apiUrl + "/api/organizations/" + id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken();

    return this.http.get(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken) });
  }

  createOrganization(organization: any) {
    const endpoint = environment.apiUrl + "/api/organizations";

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken();
    return this.http.post(endpoint, organization, { headers: new HttpHeaders().set("Authorization", bearerToken) });
  }

  updateOrganization(organization: any, rekbotIds: number[]) {
    const endpoint = environment.apiUrl + "/api/organizations/" + organization.id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken();
    return this.http.put(endpoint, {
      organization: organization,
      rekbotIds: rekbotIds
    },
       { headers: new HttpHeaders().set("Authorization", bearerToken) });
  }

  destroyOrganization(id: number) {
    const endpoint = environment.apiUrl + "/api/organizations/" + id;

    if (this.authService.getToken().length == 0) {
      this.router.navigate(['/']);
    }
    const bearerToken = "Bearer " + this.authService.getToken();
    return this.http.delete(endpoint, { headers: new HttpHeaders().set("Authorization", bearerToken) });
  }

}
